import { FORM_TYPES } from '../../../types/paramsConfig.js';
import AccountIdentifier from '../../../views/AccountIdentifier/index.js';
import TwoStepLogin from '../../../views/TwoStepLogin/index.js';
import TwoStepRegistration from '../../../views/TwoStepRegistration/index.js';
import TwoStepResetPassword from '../../../views/TwoStepResetPassword/index.js';
import TwoStepResetPasswordSuccess from '../../../views/TwoStepResetPasswordSuccess/index.js';
import AppleUpdateEmail from '../../../views/AppleUpdateEmail/index.js';
import { CVUploadModal } from '../../features/registrationSuccess/RegistrationSuccessModal/CVUploadModal.js';
import TwoStepPasswordlessConfirmation from '../../../views/TwoStepPasswordlessConfirmation/index.js';
import { LoginForm } from '../../../views/Login/index.js';
import { RegistrationForm } from '../../../views/Registration/index.js';
import { ResetPasswordForm } from '../../../views/ResetPassword/index.js';
import { LinkedInImportProfileForm } from '../../../views/LinkedInImportProfile/index.js';
import { RegistrationSuccessForm } from '../../../views/RegistrationSuccess/index.js';
export const inlineFormsConfigs = () => {
    return [
        {
            component: AccountIdentifier,
            // this is legacy - to support basicTwoStep prop passed by JobAd inlineForm
            type: FORM_TYPES.BASIC_TWO_STEP,
        },
        {
            component: LoginForm,
            type: FORM_TYPES.LOGIN,
        },
        {
            component: RegistrationForm,
            type: FORM_TYPES.REGISTRATION,
        },
        {
            component: ResetPasswordForm,
            type: FORM_TYPES.RESET_PASSWORD,
        },
        {
            component: LinkedInImportProfileForm,
            type: FORM_TYPES.LINKEDIN_IMPORT_PROFILE,
        },
        {
            component: RegistrationSuccessForm,
            type: FORM_TYPES.REGISTRATION_SUCCESS,
        },
        {
            component: AccountIdentifier,
            type: FORM_TYPES.TWO_STEP_ACCOUNT_IDENTIFIER,
        },
        {
            component: AccountIdentifier,
            type: FORM_TYPES.TWO_STEP_RETURNING,
        },
        {
            component: TwoStepLogin,
            type: FORM_TYPES.TWO_STEP_LOGIN,
        },
        {
            component: TwoStepRegistration,
            type: FORM_TYPES.TWO_STEP_REGISTRATION,
        },
        {
            component: TwoStepResetPassword,
            type: FORM_TYPES.TWO_STEP_RESET_PASSWORD,
        },
        {
            component: TwoStepResetPasswordSuccess,
            type: FORM_TYPES.TWO_STEP_RESET_PASSWORD_SUCCESS,
        },
        {
            component: CVUploadModal,
            type: FORM_TYPES.TWO_STEP_CV_UPLOAD,
        },
        {
            component: AppleUpdateEmail,
            type: FORM_TYPES.TWO_STEP_APPLE_UPDATE_EMAIL,
        },
        {
            component: TwoStepPasswordlessConfirmation,
            type: FORM_TYPES.TWO_STEP_PASSWORDLESS_CONFIRMATION,
        },
    ];
};
//# sourceMappingURL=inlineFormsConfigs.js.map